var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkIcon = function SvgCheckmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#880A47",
    d: "M12.5 1.293c-6.087 0-11.04 4.953-11.04 11.04 0 6.088 4.953 11.04 11.04 11.04 6.088 0 11.04-4.952 11.04-11.04S18.588 1.293 12.5 1.293m5.197 6.99-5.525 8.142-4.319-4.007a.48.48 0 1 1 .653-.704l3.5 3.247 4.897-7.217a.48.48 0 0 1 .794.54"
  })));
};
export default SvgCheckmarkIcon;